import type { ArchetypeProfile } from "~/api/assessmentSessions"

export function formatRarityPrimaryLine(archetypeName: string, percent: number): string {
  const oneIn = Math.round(100 / percent)
  return `Only about 1 in ${oneIn} dogs are ${archetypeName}s`
}

export function formatRaritySecondaryLine(percent: number): string {
  if (percent <= 5) return "That's pretty rare."
  if (percent <= 9) return "That's fairly uncommon."
  return "That's one of the more common personalities."
}

export function formatShareCardRarityLine(percent: number): string {
  return `Only ${percent}% of dogs have this personality`
}

export function getArchetypePopulationPercent(archetype: Pick<ArchetypeProfile, "population_percent">): number {
  const percent = archetype.population_percent
  if (typeof percent === "number" && percent > 0 && percent <= 100) {
    return percent
  }

  if (process.env.NODE_ENV !== "production") {
    console.warn("archetype missing population_percent; using fallback")
  }
  return 5
}
